import * as React from "react"

const SvgComponent = (props) => (
    <svg
        style={{
            width: 24,
            height: 24,
        }}
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            fill="#000"
            d="M8.59 16.58 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.42Z"
        />
    </svg>
)

export default SvgComponent
